import React, { useContext } from 'react'
import './style/Q3.css'
import Headling from '../Headling'
import Subtitle from '../Subtitle'
import YesOrNoQuestion from '../YesOrNoQuestion'
import { setNewAnswer } from '../../Store'
import { useHistory } from 'react-router-dom'
import StepCounter from '../StepCounter'
import gif10 from './assets/18_shop 2.gif'
import jpg10 from './assets/static/18_shop-2.jpg'

import '../Gif.css'
import ReactPixel from 'react-facebook-pixel';
import { AppContext} from '../../contexts/AppProvider'
import { useLocalize } from 'localize-react';

function Q10() {
    const { settings } = useContext(AppContext)
    const history = useHistory();
    const { translate } = useLocalize()

    return (
        <>
            <div className="picHold hid vis">
                <img className="gif10" src={settings.isAnimationPause ? jpg10 : gif10} />
            </div>
            <Headling text={translate('Apartment for Rent')} />
            <Subtitle text={translate('Do I rent my apartment?')} />
            <YesOrNoQuestion onYesClick={() => {
                setNewAnswer({
                    10: 1
                })
                history.push('/Q/11')
                ReactPixel.trackCustom('rent_home_yes', '');
            }}
                onNoClick={() => {
                    setNewAnswer({
                        10: 0
                    })
                    history.push('/Q/12')
                    ReactPixel.trackCustom('rent_home_no', '');
                }} />
            <StepCounter />

        </>
    )
}



export default Q10

